import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Card from 'components/Card';
import Panel from 'components/Panel';
import useUniqueId from 'hooks/useUniqueId';
import CalendarIntegrationContent from './CalendarIntegrationContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserCalendarIntegration() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  return /*#__PURE__*/_jsx(Card, {
    role: "region",
    "aria-labelledby": titleId,
    children: /*#__PURE__*/_jsxs(Panel, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mb: "s",
        id: titleId,
        children: t('auto_join_settings_title')
      }), /*#__PURE__*/_jsx(CalendarIntegrationContent, {})]
    })
  });
}
export default UserCalendarIntegration;